import React from 'react';

export const WhatsAppButton = () => {
    return (
        <a
            href="https://api.whatsapp.com/send?phone=919054541120&text=Hi"
            className="whatsapp_float"
            target="_blank"
            title='WhatsApp'
        >
            <i className="fa-brands fa-whatsapp"></i>
        </a>
    );
};
